import { lazy, Suspense } from "react";



const PatientDemographicsChart = lazy(() => import("./ClinicAnalytics/PatientDemographicsChart"));
const AppointmentTypesChart = lazy(() => import("./ClinicAnalytics/AppointmentTypesChart"));
const RevenueSourcesChart = lazy(() => import("./ClinicAnalytics/RevenueSourcesChart"));
const PatientSatisfactionChart = lazy(() => import("./ClinicAnalytics/PatientSatisfactionChart"));
const StaffPerformanceChart = lazy(() => import("./ClinicAnalytics/StaffPerformanceChart"));


export default function ClinicReports({ageandgenderstats,appointmentTypes,revenue}) {
  return (
    <div className="space-y-4">
      <div className="flex justify-between flex-wrap gap-2">
        <div>
          <h2 className="text-xl font-semibold" style={{fontSize:'24px'}}>Overview</h2>
          {/* <p className="text-sm text-muted-foreground">Insights and trends from your clinic data</p> */}
        </div>
        {/* <div className="flex gap-2">
          <button className="btn border">Filter</button>
          <button className="btn border">Export</button>
        </div> */}
      </div>

      {/* Top 3 charts in 3-column layout */}
      <div className="grid gap-4 md:grid-cols-2 lg:grid-cols-3">
         <Suspense fallback={<div className="text-sm">Loading...</div>}><PatientDemographicsChart ageandgenderstats={ageandgenderstats}/></Suspense>
        <Suspense fallback={<div className="text-sm">Loading...</div>}><AppointmentTypesChart appointmentTypes={appointmentTypes}/></Suspense>
        <Suspense fallback={<div className="text-sm">Loading...</div>}><RevenueSourcesChart revenue={revenue}/></Suspense>
      </div>

      {/* Bottom 2 charts in 2-column layout */}
     
    </div>
  );
}

